import { render, staticRenderFns } from "./Submitting.vue?vue&type=template&id=1246e881&scoped=true&"
import script from "./Submitting.vue?vue&type=script&lang=js&"
export * from "./Submitting.vue?vue&type=script&lang=js&"
import style0 from "./Submitting.vue?vue&type=style&index=0&id=1246e881&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1246e881",
  null
  
)

export default component.exports